import ReactDOM from "react-dom";
import { datadogRum } from "@datadog/browser-rum";
import * as Sentry from "@sentry/react";

import { appEnv } from "@utils";

import App from "./App";
import * as serviceWorker from "./serviceWorker";

import "react-app-polyfill/stable";

if (appEnv !== undefined) {
  Sentry.init({
    dsn: "https://d71a25a2a71b4d27a6cc45da98ca30ad@o77510.ingest.sentry.io/5770304",
    environment: appEnv,
  });
  datadogRum.init({
    applicationId: "df1b64eb-4e47-4f5d-94af-95405cea8774",
    clientToken: "pub92e7a5b93ab691331e1fe1b700aa1004",
    site: "datadoghq.com",
    service: "frontend",
    env: appEnv,
    sampleRate: 100,
    replaySampleRate: 100,
    defaultPrivacyLevel: "allow",
    trackInteractions: true,
    allowedTracingOrigins: [/https:[/][/].*?[.]?semgrep[.]dev/],
    beforeSend: (event) => {
      if (/https:[/][/].*?[.]?semgrep[.]dev[/]embed/.test(event.view.url)) {
        // discard events from embedded widgets
        return false;
      }
      if (
        event.type === "error" &&
        event.error.message.includes("ResizeObserver loop limit exceeded")
      ) {
        // discard ResizeObserver loop limit exceeded errors
        return false;
      }
      return;
    },
  });
  datadogRum.startSessionReplayRecording();
}

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
